import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Section, { SectionTitle } from '../../common/Section.js';
import { FaHome, FaBuilding, FaLandmark } from 'react-icons/fa';

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const ServiceCard = styled.div`
  background-color: var(--white);
  padding: 2rem;
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  cursor: ${props => props.isLink ? 'pointer' : 'default'};
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: var(--shadow-lg);
  }
  
  .icon {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--light);
    border-radius: 50%;
    margin-bottom: 1.5rem;
    
    svg {
      font-size: 2rem;
      color: var(--secondary);
    }
  }
  
  h3 {
    margin-bottom: 1rem;
  }
  
  p {
    color: var(--gray);
  }
`;

// Wrap component with Link if needed and add aggressive scroll behavior
const ServiceCardWrapper = ({ children, to, ...props }) => {
  if (to) {
    const handleClick = () => {
      // Force immediate scroll to top before navigation
      window.scrollTo({ top: 0, behavior: 'instant' });
      
      // Additional scroll attempts with timeouts to ensure it works
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }, 0);
      
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }, 50);
    };

    return (
      <Link 
        to={to} 
        style={{ textDecoration: 'none', display: 'block' }} 
        onClick={handleClick}
        {...props}
      >
        {children}
      </Link>
    );
  }
  return children;
};

const ServicesSection = () => {
  const services = [
    {
      icon: <FaHome />,
      title: 'Home Building & Sales',
      description: 'Custom home building, new construction projects, and ready-to-move-in properties available in prime NC Triad locations.',
      link: '/homes-for-sale'
    },
    {
      icon: <FaBuilding />,
      title: 'Rental Properties',
      description: 'Quality rental homes built and maintained with the same attention to detail as our for-sale properties.',
      link: '/rental-properties'
    },
    {
      icon: <FaLandmark />,
      title: 'Land Development',
      description: 'From raw land to thriving communities, we develop residential properties throughout the NC Triad area.',
      link: '/land-development'
    }
  ];
  
  return (
    <Section bg="light">
      <div className="container">
        <SectionTitle>
          <h2>Our Services</h2>
          <p>Comprehensive solutions for all your real estate and construction needs</p>
        </SectionTitle>
        
        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCardWrapper key={index} to={service.link}>
              <ServiceCard isLink={!!service.link}>
                <div className="icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </ServiceCard>
            </ServiceCardWrapper>
          ))}
        </ServicesGrid>
      </div>
    </Section>
  );
};

export default ServicesSection;